import React from "react";

const AddDataModal = ({
  onClose,
  onUploadClick,
  onFileSelected,
  onManualEntry,
  fileInputRef,
}) => {
  return (
    <div style={{ 
      background: "#fff",
      borderRadius: "12px",
      maxWidth: "600px",
      margin: "0 auto"
    }}>
      <div style={{
        background: "linear-gradient(135deg, #83c14a 0%, #6fa83d 100%)",
        padding: "24px",
        borderRadius: "12px 12px 0 0",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <div className="d-flex align-items-center gap-3">
          <div style={{
            width: "48px",
            height: "48px",
            borderRadius: "12px",
            background: "rgba(255, 255, 255, 0.2)",
            backdropFilter: "blur(10px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <i className="bi bi-plus-circle-fill" style={{ fontSize: "1.5rem", color: "#fff" }}></i>
          </div>
          <div>
            <h5 style={{ margin: 0, color: "#fff", fontWeight: "700", fontSize: "1.25rem" }}>
              Choose How to Add Data
            </h5>
            <p style={{ margin: 0, color: "rgba(255, 255, 255, 0.9)", fontSize: "0.875rem" }}>
              Select your preferred method below
            </p>
          </div>
        </div>
        <button 
          className="btn-close btn-close-white" 
          aria-label="Close" 
          onClick={onClose}
          style={{
            opacity: 0.9,
            transition: "opacity 0.2s ease"
          }}
          onMouseEnter={(e) => e.target.style.opacity = "1"}
          onMouseLeave={(e) => e.target.style.opacity = "0.9"}
        />
      </div>

      <div style={{ padding: "32px" }}>
        <div className="row g-3">
          <div className="col-md-6">
            <button
              className="btn w-100"
              style={{
                background: "#F9FAFB",
                border: "2px solid #E5E7EB",
                borderRadius: "12px",
                padding: "24px 20px",
                transition: "all 0.2s ease",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "12px"
              }}
              onClick={onUploadClick}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#F3F4F6";
                e.currentTarget.style.borderColor = "#D1D5DB";
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = "0 8px 16px rgba(0, 0, 0, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#F9FAFB";
                e.currentTarget.style.borderColor = "#E5E7EB";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <div style={{
                width: "64px",
                height: "64px",
                borderRadius: "12px",
                background: "linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                <i className="bi bi-file-earmark-spreadsheet-fill" style={{ fontSize: "1.75rem", color: "#fff" }}></i>
              </div>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "1rem", fontWeight: "700", color: "#111827", marginBottom: "4px" }}>
                  Upload File
                </div>
                <div style={{ fontSize: "0.75rem", color: "#6B7280" }}>
                  CSV / XLSX format
                </div>
              </div>
            </button>
          </div>

          <div className="col-md-6">
            <button
              className="btn w-100 text-white"
              style={{
                background: "linear-gradient(135deg, #83c14a 0%, #6fa83d 100%)",
                border: "2px solid transparent",
                borderRadius: "12px",
                padding: "24px 20px",
                transition: "all 0.2s ease",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "12px",
                boxShadow: "0 4px 12px rgba(131, 193, 74, 0.3)"
              }}
              onClick={onManualEntry}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(131, 193, 74, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(131, 193, 74, 0.3)";
              }}
            >
              <div style={{
                width: "64px",
                height: "64px",
                borderRadius: "12px",
                background: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(10px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                <i className="bi bi-pencil-square" style={{ fontSize: "1.75rem", color: "#fff" }}></i>
              </div>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "1rem", fontWeight: "700", marginBottom: "4px" }}>
                  Manual Entry
                </div>
                <div style={{ fontSize: "0.75rem", opacity: 0.9 }}>
                  Enter data manually
                </div>
              </div>
            </button>
          </div>
        </div>

        {/* Hidden input for file selection */}
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv,.xlsx,.xls"
          style={{ display: "none" }}
          onChange={onFileSelected}
        />
      </div>
    </div>
  );
};

export default AddDataModal;
